import { cn } from "@/lib/utils";

interface TelegramIconProps {
  className?: string;
}

/** Telegram paper-plane brand mark. Uses currentColor for theme-aware placement. */
export function TelegramIcon({ className }: TelegramIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      <path d="M21.8 3.36c.3-1.22-.95-2.22-2.08-1.67L2.67 9.98c-1.27.62-1.19 2.46.14 2.97l4.13 1.58 1.6 5.02c.38 1.2 1.9 1.56 2.78.66l2.3-2.35 4.48 3.3c.99.73 2.4.2 2.65-1.01L21.8 3.36ZM8.5 13.28l8.95-6.63-7.11 7.66-.7 3.22-1.14-4.25Z" />
    </svg>
  );
}
